// extracted by mini-css-extract-plugin
export default {"rating":"DJ-z","numberOfStars":"EJ-z","count":"FJ-z","barGraphSpacing":"GJ-z","barGraph":"HJ-z"};